import { $, $$ } from 'utils/dom';
import { slideOpen, slideClose } from 'modules/shower';

const navigation = $('.navigation');

if (navigation) {
  const mainButtons = $$('.navigation__main-button', navigation);

  const openSublist = mainButton => {
    const sublist = $(`#${mainButton.getAttribute('aria-controls')}`);
    if (sublist) {
      const mainButtonsWithoutOpenButton = mainButtons.filter(
        button => mainButton !== button
      );

      closeSublists(mainButtonsWithoutOpenButton);
      sublist.setAttribute('aria-hidden', false);
      mainButton.setAttribute('aria-expanded', true);
      slideOpen(sublist);
    }
  };

  const closeSublist = mainButton => {
    if (!mainButton.getAttribute('aria-expanded')) return;

    const sublist = $(`#${mainButton.getAttribute('aria-controls')}`);

    if (sublist) {
      sublist.setAttribute('aria-hidden', true);
      mainButton.setAttribute('aria-expanded', false);
      slideClose(sublist);
    }
  };

  const closeSublists = mainButtons => {
    mainButtons.forEach(mainButton => {
      closeSublist(mainButton);
    });
  };

  mainButtons.forEach(mainButton => {
    mainButton.addEventListener('click', event => {
      const isDesktop = window.innerWidth > 1199;
      if (isDesktop) return;
      const targetSublist = $(`#${mainButton.getAttribute('aria-controls')}`);
      if (targetSublist) {
        const isClosed = targetSublist.getAttribute('aria-hidden') === 'true';

        if (isClosed) {
          // open
          openSublist(mainButton);
        } else {
          // close
          closeSublist(mainButton);
        }
      }

      event.stopPropagation();
    });
  });

  const body = $('body');
  body.addEventListener('click', event => {
    const isDesktop = window.innerWidth > 1199;
    if (isDesktop) return;
    const clickTarget = event.target;
    if (clickTarget.classList.contains('navigation__main-link')) return;
    closeSublists(mainButtons);
  });

  const burgerBtn = $('.burger-menu', navigation);
  const navMain = $('.navigation__outer', navigation);
  const navInner = $('.navigation__inner', navigation);

  const openBurger = () => {
    burgerBtn.classList.add('is-open');
    burgerBtn.setAttribute('aria-expanded', 'true');
    navMain.classList.add('is-open');
    navInner.classList.add('is-open');
    navMain.setAttribute('aria-hidden', 'false');
    $('body').style.overflow = 'hidden';
  };

  const closeBurger = () => {
    burgerBtn.classList.remove('is-open');
    burgerBtn.setAttribute('aria-expanded', 'false');
    navMain.classList.remove('is-open');
    navInner.classList.remove('is-open');
    navMain.setAttribute('aria-hidden', 'true');
    $('body').removeAttribute('style');
  };

  burgerBtn.addEventListener('click', () => {
    const isAlreadyOpen = burgerBtn.classList.contains('is-open');
    if (isAlreadyOpen) {
      closeBurger();
    } else {
      openBurger();
    }
  });

  let lastIsDesktop = true;
  const handleResize = () => {
    const isDesktop = window.innerWidth > 1199;

    if (isDesktop !== lastIsDesktop) {
      if (isDesktop) {
        closeBurger();
        closeSublists(mainButtons);
      }

      lastIsDesktop = isDesktop;
    }
  };

  window.addEventListener('resize', () => handleResize());

  const stickyScroll = () => {
    const windowPosTop = window.pageYOffset;

    if (windowPosTop > 5) {
      navigation.classList.add('navigation--fixed');
    } else {
      navigation.classList.remove('navigation--fixed');
    }
  };
  window.addEventListener('scroll', () => stickyScroll());
}

// shower für mobile
// shower auf desktop animations zeit 0
// burger toggle fährt menü ein und aus (.navigation__menu)

// on resize from tablet to desktop close all navigation__main-sublists
// reset aria lables like in closeSublist
// window.addEventListener('resize', () => handleResize());
// if (window.innerWidth <= 1366px)

/*
 ✓ wenn click auf main-link check if anderes ist offen und schliese es.
  -> alle navgation__main-sublists sammeln
    und aria-hidden true
  -> alle mainLinks sammeln
    aria-expanded false

 ✓ wenn click  auf body schließe navigation__main-sublist
  -> herausfinden ob geklickt wurde
  -> Event Listener
  -> wenn geklickt wurde  -> hideSublists()
  -> alle navigation__main-sublists sammeln
    und aria-hidden true
  -> alle mainLinks sammeln
    und aria-expanded false
  */
